import type { QueryClient } from "@tanstack/react-query";
import {
  classesByIdsQueryKey,
  fetchAndSeedClassesByIds,
  uniqueSortedClassIds,
} from "@/features/classes/hooks/classes-by-ids-query";

export async function prefetchClassesByIds(
  queryClient: QueryClient,
  classIds: number[],
  accessToken: string,
) {
  if (!accessToken) {
    throw new Error("Access token is required for prefetching classes");
  }

  const uniqueIds = uniqueSortedClassIds(classIds);
  if (uniqueIds.length === 0) {
    return queryClient;
  }

  await queryClient.prefetchQuery({
    queryKey: classesByIdsQueryKey(uniqueIds),
    queryFn: () =>
      fetchAndSeedClassesByIds(queryClient, accessToken, uniqueIds),
    staleTime: 5 * 60 * 1000,
  });

  return queryClient;
}
